export default {
  localization: {
    eventTypes: {
      commented: {
        absolute: 'You commented on {absoluteTime}',
        relative: 'You commented {relativeTime}',
        standalone: 'You commented',
        multiAbsolute: 'Commented on {absoluteTime}',
        multiRelative: 'Commented {relativeTime}',
        multiStandalone: 'Commented'
      },
      created: {
        absolute: 'You created on {absoluteTime}',
        relative: 'You created {relativeTime}',
        standalone: 'You created',
        multiAbsolute: 'Created on {absoluteTime}',
        multiRelative: 'Created {relativeTime}',
        multiStandalone: 'Created'
      },
      edited: {
        absolute: 'You edited on {absoluteTime}',
        relative: 'You edited {relativeTime}',
        standalone: 'You edited',
        multiAbsolute: 'Edited on {absoluteTime}',
        multiRelative: 'Edited {relativeTime}',
        multiStandalone: 'Edited'
      },
      published: {
        absolute: 'You published on {absoluteTime}',
        relative: 'You published {relativeTime}',
        standalone: 'You published',
        multiAbsolute: 'Published on {absoluteTime}',
        multiRelative: 'Published {relativeTime}',
        multiStandalone: 'Published'
      },
      updated: {
        absolute: 'You updated on {absoluteTime}',
        relative: 'You updated {relativeTime}',
        standalone: 'You updated',
        multiAbsolute: 'Updated on {absoluteTime}',
        multiRelative: 'Updated {relativeTime}',
        multiStandalone: 'Updated'
      },
      viewed: {
        absolute: 'You viewed on {absoluteTime}',
        relative: 'You viewed {relativeTime}',
        standalone: 'You viewed',
        multiAbsolute: 'Viewed on {absoluteTime}',
        multiRelative: 'Viewed {relativeTime}',
        multiStandalone: 'Viewed'
      }
    }
  },
  hydrators: {
    TownsquareGoal: {
      hydratorPaths: {
        id: ['id'],
        key: ['key'],
        name: ['name'],
        url: ['url'],
        icon: ['iconData']
      }
    },
    TownsquareProject: {
      hydratorPaths: {
        id: ['id'],
        key: ['key'],
        name: ['name'],
        url: ['url'],
        icon: ['iconData']
      }
    },
    TownsquareComment: {
      hydratorPaths: {
        id: ['id'],
        key: ['container.key'],
        name: ['container.name'],
        url: ['container.url'],
        icon: ['container.iconData'],
        deduplicateId: ['container.id']
      }
    },
    ConfluencePage: {
      hydratorPaths: {
        id: ['id'],
        name: ['title'],
        localResourceId: ['pageId'],
        subtype: ['subtype'],
        url: ['links.base', 'links.webUi'],
        containers: ['space.name']
      },
      staticFallbacks: {
        icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
        confluenceLiveDocIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/live-doc.svg'
      }
    },
    ConfluenceBlogPost: {
      hydratorPaths: {
        id: ['id'],
        name: ['title'],
        localResourceId: ['blogPostId'],
        url: ['links.base', 'links.webUi'],
        containers: ['space.name']
      },
      staticFallbacks: {
        icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
      }
    },
    ConfluenceComment: {
      hydratorPaths: {
        id: ['id'],
        name: ['container.title'],
        url: ['links.base', 'links.webUi'],
        containers: ['container.space.name'],
        deduplicateId: ['container.id']
      },
      staticFallbacks: {
        icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
        confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
        confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
      }
    },
    ConfluenceFooterComment: {
      hydratorPaths: {
        id: ['id'],
        name: ['container.title'],
        url: ['links.base', 'links.webUi'],
        containers: ['container.space.name'],
        deduplicateId: ['container.id']
      },
      staticFallbacks: {
        icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
        confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
        confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
      }
    },
    ConfluenceInlineComment: {
      hydratorPaths: {
        id: ['id'],
        name: ['container.title'],
        url: ['links.base', 'links.webUi'],
        containers: ['container.space.name'],
        deduplicateId: ['container.id']
      },
      staticFallbacks: {
        icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
        confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
        confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
      }
    },
    JiraIssue: {
      hydratorPaths: {
        id: ['id'],
        name: ['fieldsById.edges(node.fieldId: "summary").node.text'],
        url: ['webUrl'],
        containers: ['fieldsById.edges(node.fieldId: "project").node.project.name'],
        icon: ['fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'],
        key: ['key']
      }
    },
    JiraPlatformComment: {
      hydratorPaths: {
        id: ['commentId'],
        name: ['issue.fieldsById.edges(node.fieldId: "summary").node.text'],
        url: ['webUrl'],
        containers: ['issue.fieldsById.edges(node.fieldId: "project").node.project.name'],
        icon: ['issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'],
        key: ['issue.key'],
        deduplicateId: ['issue.id']
      }
    },
    JiraServiceManagementComment: {
      hydratorPaths: {
        id: ['commentId'],
        name: ['issue.fieldsById.edges(node.fieldId: "summary").node.text'],
        url: ['webUrl'],
        containers: ['issue.fieldsById.edges(node.fieldId: "project").node.project.name'],
        icon: ['issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'],
        key: ['issue.key'],
        deduplicateId: ['issue.id']
      }
    }
  },
  queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};